var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubeGrandeIzquierdaNaranjaBirdybuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 136,
    viewBox: "0 0 304 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5029 135.264C106.006 135.264 238 135.264 238 135.264C253.32 135.526 265.883 123.528 265.883 108.631C265.883 93.9188 253.617 81.9924 238.486 81.9924H162.211C149.763 81.9924 139.673 72.182 139.673 60.0782C139.673 47.9744 149.763 38.1639 162.211 38.1639H283.378C294.218 38.1639 303.003 29.6216 303.003 19.0817C303.003 8.54181 294.218 -0.000488281 283.378 -0.000488281H0.00292969C0.00292969 -0.000488281 0.00292969 6.49905 0.00292969 54.4995C0.00292969 102.5 51 135.264 78.5029 135.264Z",
    fill: "#FFD2B0",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubeGrandeIzquierdaNaranjaBirdybuyer);
export default __webpack_public_path__ + "static/media/nube-grande-izquierda-naranja-birdybuyer.d865e7d23c6cd18723bcdd1772db8b6d.svg";
export { ForwardRef as ReactComponent };